var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFulled = function SvgStarFulled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star-fulled_svg__a)",
    d: "M8.69.826a1.45 1.45 0 0 1 2.62 0l1.966 4.015c.215.438.627.741 1.102.81l4.364.64c1.207.176 1.686 1.695.807 2.559l-3.131 3.073a1.52 1.52 0 0 0-.428 1.335l.743 4.361c.207 1.22-1.041 2.154-2.117 1.585l-3.942-2.088a1.44 1.44 0 0 0-1.348 0l-3.943 2.088c-1.075.57-2.323-.366-2.116-1.585l.743-4.36c.084-.49-.077-.991-.428-1.336L.452 8.85c-.88-.864-.401-2.383.806-2.56l4.364-.638c.475-.07.887-.373 1.102-.811z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-fulled_svg__a",
    x1: 10,
    x2: 10,
    y1: 0,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })))));
};
export default SvgStarFulled;